import { useContext, useState, useEffect } from 'react';
import { Grid, InputLabel, FormControl, Select, Button, Table, TableHead, TableBody, TableRow, TableCell, FormHelperText, MenuItem } from '@material-ui/core';
import { TablesContext } from '../TablesContext';
import { SapTableNames, LocalTableNames, } from '../../../../../helpers';
import { makeStyles } from '@material-ui/core/styles';
import { DbType } from '../../../../../helpers/Common';
import { getTableValuesItemsCodeByDBType } from '../../../../../helpers/Utils';

const useStyles = makeStyles((theme) => ({
    root: {
    },
    formGroup: {
        width: '100%',
    },
    select: {
        width: '100%'
    },
    addbutton: {
    },
    mappings: {
        marginTop: theme.spacing(4)
    },
    removeButton: {
    }
}));

export const AccountGroupMappingS4 = (props) => {
    const classes = useStyles();

    const {
        state,
        getDistributionChannels,
        getAccountGroupMappingsValueName,
        getAccountGroupMappingsValueNameCode,
        isAddingAccGroupMappingS4,
        addAccountGroupMappingS4,
        isDeletingAccGroupMapping,
        deleteAccountGroupMapping
    } = useContext(TablesContext);

    const {
        accountGroupMappingsS4
    } = state;

    const [salesOrganizationId, setSalesOrganizationId] = useState("");
    const salesOrgSelectHandler = (e) => {
        setSalesOrganizationId(e.target.value);
    };

    const [businessCategoryId, setBusinessCategoryId] = useState("");
    const buCateogrySelectHandler = (e) => {
        setBusinessCategoryId(e.target.value);
    };

    const [accountGroupId, setAccountGroupId] = useState("");
    const accountGroupSelectHandler = (e) => {
        setAccountGroupId(e.target.value);
    };

    const [customerGroupId, setCustomerGroupId] = useState("");
    const customerGroupSelectHandler = (e) => {
        setCustomerGroupId(e.target.value);
    };

    const [customerGroup6Id, setCustomerGroup6Id] = useState("");
    const customerGroup6SelectHandler = (e) => {
        setCustomerGroup6Id(e.target.value);
    };

    const [divisionId, setDivisionId] = useState("");
    const divisionSelectHandler = (e) => {
        setDivisionId(e.target.value);
    };

    const [distributionChannelId, setDistributionChannelId] = useState("");
    const distChannelSelectHandler = (e) => {
        setDistributionChannelId(e.target.value);
    };

    const addMappingClickHandler = async () => {
        const success = await addAccountGroupMappingS4({
            salesOrganizationId,
            businessCategoryId,
            accountGroupId,
            customerGroupId,
            customerGroup6Id,
            divisionId,
            distributionChannelId
        });

        if (success) {
            setSalesOrganizationId("");
            setBusinessCategoryId("");
            setAccountGroupId("");
            setCustomerGroupId("");
            setCustomerGroup6Id("");
            setDivisionId("");
            setDistributionChannelId("");
        }
    };

    const deleteMappingClickHandler = async (mapping) => {
        await deleteAccountGroupMapping(mapping.accountGroupMappingId, DbType.S4);
    };

    useEffect(() => {
        if (customerGroup6Id !== "") {
            setDistributionChannelId("");
            getDistributionChannels(customerGroup6Id);
        }
    }, [customerGroup6Id]);

    const [canAddMapping, setCanAddMapping] = useState(false);
    useEffect(() => {
        setCanAddMapping(
            salesOrganizationId !== "" &&
            businessCategoryId !== "" &&
            accountGroupId !== "" &&
            customerGroupId !== "" &&
            customerGroup6Id !== "" &&
            divisionId !== "" &&
            distributionChannelId !== "" &&
            !isAddingAccGroupMappingS4
        );
    }, [salesOrganizationId, businessCategoryId, accountGroupId, customerGroupId, customerGroup6Id, divisionId, distributionChannelId, isAddingAccGroupMappingS4]);

    const getOrderedMappings = () => {
        const orderedAccGrpMapping = [].concat(accountGroupMappingsS4);
        orderedAccGrpMapping.map(mapping => {
            mapping.salesOrganizationName = getAccountGroupMappingsValueNameCode(
                SapTableNames.SalesOrganizations,
                mapping.salesOrganizationId,
                DbType.S4
            );
        });

        const sortBySalesOrganizationName = (a, b) => {
            if (
                (
                    a.salesOrganizationName &&
                    a.salesOrganizationName.split(" - ")[0]
                ) <
                (
                    b.salesOrganizationName &&
                    b.salesOrganizationName.split(" - ")[0]
                )
            )
                return -1;

            if (
                (
                    a.salesOrganizationName &&
                    a.salesOrganizationName.split(" - ")[0]
                ) >
                (
                    b.salesOrganizationName &&
                    b.salesOrganizationName.split(" - ")[0]
                )
            )
                return 1;

            return 0;
        };

        orderedAccGrpMapping.sort(sortBySalesOrganizationName);

        return orderedAccGrpMapping;
    };

    return (
        <Grid container>
            <Grid item xs={12}>
                <Grid
                    container
                    spacing={3}
                    justifyContent="flex-start"
                    alignItems="flex-end"
                >
                    <Grid item xs={12} sm={12} md={12} lg={2}>
                        <FormControl className={classes.formGroup}>
                            <InputLabel id="sales-group-label-s4">
                                Sales Organization
                            </InputLabel>
                            <Select
                                labelId="sales-group-label-s4"
                                className={classes.select}
                                value={salesOrganizationId}
                                disabled={isAddingAccGroupMappingS4}
                                onChange={salesOrgSelectHandler}
                            >
                                {getTableValuesItemsCodeByDBType(SapTableNames.SalesOrganizations, state, DbType.S4)}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={2}>
                        <FormControl className={classes.formGroup}>
                            <InputLabel id="sales-group-label-s4">
                                Business Category
                            </InputLabel>
                            <Select
                                labelId="sales-group-label-s4"
                                className={classes.select}
                                value={businessCategoryId}
                                disabled={isAddingAccGroupMappingS4}
                                onChange={buCateogrySelectHandler}
                            >
                                {getTableValuesItemsCodeByDBType(LocalTableNames.BusinessCategories, state, DbType.S4)}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={2}>
                        <FormControl className={classes.formGroup}>
                            <InputLabel id="sales-group-label-s4">
                                Account Group
                            </InputLabel>
                            <Select
                                labelId="sales-group-label-s4"
                                className={classes.select}
                                value={accountGroupId}
                                disabled={isAddingAccGroupMappingS4}
                                onChange={accountGroupSelectHandler}
                            >
                                {getTableValuesItemsCodeByDBType(SapTableNames.AccountGroups, state, DbType.S4)}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={2}>
                        <FormControl className={classes.formGroup}>
                            <InputLabel id="sales-group-label-s4">
                                Customer Group
                            </InputLabel>
                            <Select
                                labelId="sales-group-label-s4"
                                className={classes.select}
                                value={customerGroupId}
                                disabled={isAddingAccGroupMappingS4}
                                onChange={customerGroupSelectHandler}
                            >
                                {getTableValuesItemsCodeByDBType(SapTableNames.CustomerGroups, state, DbType.S4)}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={2}>
                        <FormControl className={classes.formGroup}>
                            <InputLabel id="sales-group-label-s4">
                                Customer Group 6
                            </InputLabel>
                            <Select
                                labelId="sales-group-label-s4"
                                className={classes.select}
                                value={customerGroup6Id}
                                disabled={isAddingAccGroupMappingS4}
                                onChange={customerGroup6SelectHandler}
                            >
                                {getTableValuesItemsCodeByDBType(SapTableNames.CustomerGroups6, state, DbType.S4)}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={2}>
                        <FormControl className={classes.formGroup}>
                            <InputLabel id="sales-group-label-s4">
                                Distribution Channel
                            </InputLabel>
                            <Select
                                labelId="sales-group-label-s4"
                                className={classes.select}
                                value={distributionChannelId}
                                disabled={
                                    isAddingAccGroupMappingS4 ||
                                    customerGroup6Id === ""
                                }
                                onChange={distChannelSelectHandler}
                            >
                                {
                                    state.distributionChannels.map((item, index: number): JSX.Element =>
                                        <MenuItem
                                            key={index}
                                            value={item.tableValueId}
                                        >
                                            {item.externalKey} - {item.value}
                                        </MenuItem>
                                    )
                                }
                            </Select>
                            <FormHelperText style={{ position: 'absolute', top: 50 }}>
                                It depends on the Customer Group 6
                            </FormHelperText>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={2}>
                        <FormControl className={classes.formGroup}>
                            <InputLabel id="sales-group-label-s4">
                                Division
                            </InputLabel>
                            <Select
                                labelId="sales-group-label-s4"
                                className={classes.select}
                                value={divisionId}
                                disabled={isAddingAccGroupMappingS4}
                                onChange={divisionSelectHandler}
                            >
                                {getTableValuesItemsCodeByDBType(SapTableNames.Divisions, state, DbType.S4)}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={2}>
                        <Button
                            className={classes.addbutton}
                            color="default"
                            variant="contained"
                            disabled={!canAddMapping}
                            onClick={addMappingClickHandler}
                        >
                            Add Mapping
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={12}>
                <Table className={classes.mappings}>
                    <TableHead>
                        <TableRow>
                            <TableCell>
                                Sales Organization
                            </TableCell>
                            <TableCell>
                                Business Category
                            </TableCell>
                            <TableCell>
                                Account Group
                            </TableCell>
                            <TableCell>
                                Customer Group
                            </TableCell>
                            <TableCell>
                                Customer Group 6
                            </TableCell>
                            <TableCell>
                                Distribution Channel
                            </TableCell>
                            <TableCell>
                                Division
                            </TableCell>
                            <TableCell>
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            getOrderedMappings().map((mapping, index: number): JSX.Element =>
                                <TableRow key={index}>
                                    <TableCell>
                                        {mapping.salesOrganizationName}
                                    </TableCell>
                                    <TableCell>
                                        {
                                            getAccountGroupMappingsValueName(
                                                LocalTableNames.BusinessCategories,
                                                mapping.businessCategoryId,
                                                DbType.S4
                                            )
                                        }
                                    </TableCell>
                                    <TableCell>
                                        {
                                            getAccountGroupMappingsValueNameCode(
                                                SapTableNames.AccountGroups,
                                                mapping.accountGroupId,
                                                DbType.S4
                                            )
                                        }
                                    </TableCell>
                                    <TableCell>
                                        {
                                            getAccountGroupMappingsValueNameCode(
                                                SapTableNames.CustomerGroups,
                                                mapping.customerGroupId,
                                                DbType.S4
                                            )
                                        }
                                    </TableCell>
                                    <TableCell>
                                        {
                                            getAccountGroupMappingsValueNameCode(
                                                SapTableNames.CustomerGroups6,
                                                mapping.customerGroup6Id,
                                                DbType.S4
                                            )
                                        }
                                    </TableCell>
                                    <TableCell>
                                        {
                                            getAccountGroupMappingsValueNameCode(
                                                SapTableNames.DistributionChannels,
                                                mapping.distributionChannelId,
                                                DbType.S4
                                            )
                                        }
                                    </TableCell>
                                    <TableCell>
                                        {
                                            getAccountGroupMappingsValueNameCode(
                                                SapTableNames.Divisions,
                                                mapping.divisionId,
                                                DbType.S4
                                            )
                                        }
                                    </TableCell>
                                    <TableCell>
                                        <Button
                                            color="secondary"
                                            disabled={isDeletingAccGroupMapping}
                                            size="small"
                                            variant="contained"
                                            onClick={() => deleteMappingClickHandler(mapping)}
                                        >
                                            Delete
                                        </Button>
                                    </TableCell>
                                </TableRow>
                            )
                        }
                    </TableBody>
                </Table>
            </Grid>
        </Grid>
    );
};